import { parse, format, isValid } from 'date-fns';

export const parseDate = (str) => {
    if (!str || str === "//") return null;
    const date = parse(str, "MM/dd/yyyy", new Date());
    return isValid(date) ? date : null;
};

export const formatDate = (date) => {
    if (!date || !isValid(date)) return "";
    return format(date, "MM/dd/yyyy");
};

export const toHtmlInputDate = (mmddyyyy) => {
    const date = parseDate(mmddyyyy);
    return date ? format(date, "yyyy-MM-dd") : "";
};

export const fromHtmlInputDate = (yyyymmdd) => {
    const parsed = parse(yyyymmdd, "yyyy-MM-dd", new Date());
    return isValid(parsed) ? format(parsed, "MM/dd/yyyy") : "";
};

/**
 * Get current America/Phoenix date in YYYY-MM-DD format
 * Falls back to UTC if timezone not available.
 */
export const getPhoenixISODate = () => {
    try {
        const opts = {
            timeZone: 'America/Phoenix',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        };

        const parts = new Intl.DateTimeFormat('en-CA', opts).format(new Date());
        // en-CA locale produces YYYY-MM-DD by default
        return parts;
    } catch (err) {
        // fallback to UTC date
        return new Date().toISOString().slice(0, 10);
    }
};
